// @ts-nocheck



import React from 'react';


import { channelApi } from '../../lib/api';

import { formatDateTimeToString } from '../../lib/helpers';
import AutocompleteSelect from './AutocompleteSelect';



export default ({ filter = {}, ...selectProps }) =>
<AutocompleteSelect
  fetch={channelApi.fetch}
  refetchParams={{ filter }}
  fetchSingle={channelApi.get}
  notFoundText="Каналы не найдены"
  placeholder="Выберите канал"
  renderOption={(channel, Option) =>
  <Option key={channel.id} value={channel.id} channel={channel}>
        {channel.channelId}
      </Option>
  }
  {...selectProps} />;
